const useRecaptcha = (action: string) => {

  // const { executeRecaptcha } = useGoogleReCaptcha();

  return {
    verify: async (): Promise<string> => {

      const siteKey = '6LcePkwrAAAAAB80XOPYmT3bFfrGDMczdSJ9wEM4';//import.meta.env.VITE_RECAPTCHA_SITE_KEY
      return await window.grecaptcha.enterprise.execute(siteKey, {action})
    }
  }
}


export default useRecaptcha
